import { getGA4Context } from '../../helpers';
import { tracker } from '../track';
export const trackConfirmFilter = ({ element, context, filterLvl, filtersValue, length, info, campaignId, }) => {
    const confirmFilter = {
        context: context || getGA4Context(),
        element,
        filter_lvl: filterLvl !== null && filterLvl !== void 0 ? filterLvl : null,
        filters_value: filtersValue,
        length: length || null,
        info: info || '',
        promotion_id: campaignId || null,
    };
    tracker.track('GA4-confirm_filter', {
        event_name: 'confirm_filter',
        confirm_filter: confirmFilter,
    });
};
